import React, { useState } from 'react';
import { useMutation } from '@apollo/client';
import { SIGNUP } from '../utils/mutations';
import Auth from '../utils/auth';
import { lineWobble } from 'ldrs'
import { useApolloClient } from '@apollo/client';
import { GET_ME } from '../utils/queries';

lineWobble.register()

const Register = (props) => {
  const [loading, setLoading] = useState(false);
  const client = useApolloClient();

  function generateRandomBase64String(length) {
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    var result = '';
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return result;
  }
  
  // Generate a random base 64 32 character string
  var randomBase64StringUser = generateRandomBase64String(16);
  var randomBase64StringPassword = generateRandomBase64String(16);

  const [formState, setFormState] = useState({
    username: randomBase64StringUser,
    password: randomBase64StringPassword,
  });
  const [signUp, { error, data }] = useMutation(SIGNUP);

  // update state based on form input changes
  const handleChange = (event) => {
    const { name, value } = event.target;

    setFormState({
      ...formState,
      [name]: value,
    });
  };

  // submit form
 const handleFormSubmit = async (event) => {
  event.preventDefault();
  setLoading(true);

  try {
    const { data } = await signUp({ variables: { ...formState } });

    const token = data?.signUp?.token;
    if (token) {
      Auth.login(token);

      // Important: make Apollo re-run queries that depend on auth headers
      await client.resetStore(); // clears & refetches active queries

      // Optionally: fetch the user explicitly and push into parent state
      const meRes = await client.query({
        query: GET_ME,
        fetchPolicy: 'network-only',
      });

      props.setCurrentUser?.(meRes?.data?.me);

      props.setIsRegisterPaneOpen(false);
    }
  } catch (e) {
    console.error(e);
    alert("There was an error. Please try a different username and password.");
    props.setIsRegisterPaneOpen(false);
  } finally {
    setLoading(false);
  }
};

  // Print the random base 64 32 character string to the console
  return (
    <main className="p-5 m-5 flex flex-col">
      <div className="flex flex-col">
        <div className="flex flex-col">
          <div className="flex flex-col">
            {loading ? (
              <div className="flex flex-col items-center justify-center">
                <span className="text-center mb-3">Registering account.<br/>Please save credentials after registration into password manager,<br/>you will not be able to recover lost passwords.</span>
                <l-line-wobble
                  size="100"
                  stroke="5"
                  bg-opacity="0.1"
                  speed="1.75" 
                  color="white" 
                  className="items-center justify-center" 
                ></l-line-wobble>
              </div>
            ) : (
              
              <form className="flex flex-col" onSubmit={handleFormSubmit}>
                <span className="text-center text-xl" style={{fontSize: "32px", margin: "20px"}}>Register</span>
                <div className="flex gap-4 items-center flex-col"> 
                <p>We've generated a random username and password for you.</p>
                  <input
                    className="input-active"
                    placeholder="Username (Public)"
                    name="username"
                    type="text"
                    value={formState.username}
                    onChange={handleChange}
                  />
                <input
                  className="input-active"
                  placeholder="Password"
                  name="password"
                  type="password"
                  value={formState.password}
                  onChange={handleChange}
                />
                <p className="fs-7 text-center">Sign up in one click!<br/>Make sure you save your password!</p>
                 <button style={{ cursor: 'pointer' }} type="submit" className="btn-active">Register</button>
                 <p className="text-center">Already have an account?</p>
                 <button style={{ cursor: 'pointer' }} onClick={() =>  { props.setIsLoginPaneOpen(true); props.setIsRegisterPaneOpen(false); }} className="btn-active">Log In</button>
              </div>
              </form>
            )}

            {error && console.log(error) && (
              <div className="text-center">
               There was an error.
              </div>
            )}
            
          </div>
        </div>
      </div>
    </main>
  );
};

export default Register;
